import React from 'react';

// Renders per-route head metadata. Relies on React 19 native head hoisting:
// <title>, <meta>, and <link rel> elements rendered anywhere in the tree are
// hoisted to <head> automatically. No provider, no dependency.
//
// This component is additive: if omitted from a page, the defaults in
// public/index.html continue to apply. Never throws; safe on any route.

const SITE_URL = 'https://lotushealingspa.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

type Props = {
  title: string;
  description: string;
  path: string;
  image?: string;
  noindex?: boolean;
};

const SEO: React.FC<Props> = ({ title, description, path, image, noindex }) => {
  const canonical = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_OG_IMAGE;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Healing Lotus Skin Spa" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </>
  );
};

export default SEO;
